//import { createSemanticDiagnosticsBuilderProgram } from "typescript";

export default class Map_DynamicMissionMaterial {


  events;

  constructor( events) {
    this.events = events;

  }

  getSvgStep(index) {
    return new Cesium.CallbackProperty(() => {

      let color = Cesium.Color.fromCssColorString("#2D5C88");
      let colorText = Cesium.Color.fromCssColorString("#FFFFFF");
      let pointLabel = (index + 1).toString();

      if(this.events.geom.isFirst(index)) {
        color = Cesium.Color.fromCssColorString("#51ff00");
        colorText = Cesium.Color.fromBytes(0, 0, 0);
        pointLabel = "D";
      }
      else if(this.events.geom.isLast(index)) {
        color = Cesium.Color.fromCssColorString("#e11900");
        pointLabel = "A";
      }

      if(this.events.isPicked(index) === true || this.events.isSelected(index) === true) {
        color = Cesium.Color.YELLOW.withAlpha(0.8);
      }

      let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 80 80">
        <path d="M 38.0,80 10.0,16.0 H 70.0 Z" fill="` +
        color.toCssColorString() +
        `"/>
        <text transform="translate(36 50)" fill="` +
        colorText.toCssColorString() +
        `" font-size="35" font-family="ArialMT, Arial"><tspan x="-9.733" y="0">` +
        pointLabel +
        `</tspan></text>`

      if(this.events.isNoReturn(index)) {
        svg += `<rect fill="#d90000" stroke="#d7d7d7" stroke-width="1" width="60.0" height="10.0" x="10.0" y="3.5"/>`;
      }
      svg += `</svg>`;

      return `data:image/svg+xml;base64,` + btoa(svg);
    }, false);
  }

  getSvgCircle() {
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 10 10">`;
    svg += `<circle fill="#ffffff" fill-opacity="0.8" stroke-width="0.2" stroke="#d7d7d7" cx="5" cy="5" r="5" />`;
    svg += `</svg>`;
    return `data:image/svg+xml;base64,` + btoa(svg);
  }

  getColor(index, alpha) {

    return new Cesium.CallbackProperty(() => {
      if (this.events.isPicked(index) === true || this.events.isSelected(index) === true) {
        return Cesium.Color.YELLOW.withAlpha(alpha);
      } else {
        return Cesium.Color.WHITE.withAlpha(alpha);
      }
    }, false);
  }
/*
  getArrowColor(index, alpha) {
    return new Cesium.CallbackProperty(() => {
      if (this.events.isPicked(index) == true) {
        return Cesium.Color.WHITE.withAlpha(0.4);
      } else {
        return Cesium.Color.WHITE.withAlpha(alpha);
      }
    }, false);
  }*/

  getLineMaterial(index) {
    let material = new Cesium.PolylineDashMaterialProperty({
      color: this.getColor(index, 0.8),
    });
    return material;
  }

  getPolylineMaterial() {
    let material = new Cesium.PolylineOutlineMaterialProperty({
      color: Cesium.Color.WHITE,
      outlineWidth: 1,
      outlineColor: Cesium.Color.BLACK,
    });
    return material;
  }


  getArrowLineMaterial() {
    let material = new Cesium.PolylineArrowMaterialProperty(
      Cesium.Color.WHITE.withAlpha(0.8)
    );
    return material;
  };
}